
window.options.slickOptions.slidesToScroll = 4;
window.options.slickOptions.slidesToScroll_Tablet = 2;
